<script>
const data = [];

export default {
    data() {
        return {
            data,
            items: {},
            highest_score: {},
            announcements: {},
            trainings: {},
            timelines: {
                timeline: []
            },
            graphics: {
                categories_avg: []
            },
            loading: true,
            loadingBank: true,
            loadingScores: true,
            loadingAnnouncements: true,
            loadingTimeline: true,
        };
    },
    created() {
        this.getTraining()
        this.getHigestScore();
        this.getAnnouncements();
        this.getGraphics();
        this.getTimeline();
    },
    computed: {
        username() {
            return window.Laravel.user.name;
        },
        email() {
            return window.Laravel.user.email;
        },
        photo() {
            return window.Laravel.user.photo;
        },
        chartData() {
            //let labels = ['Managerial Competencies', 'Technical Competencies', 'Enabling Competencies']
            let labels = []

            let datas = []

            this.graphics.categories_avg.forEach((item) => {
                datas.push(item.material_avg)
                labels.push(item.name)
            })

            let data = {
                //data: this.graphics.categories_avg.map(item => item.material_avg),
                data: datas,
                barThickness: 30,
                backgroundColor: '#f87979'
            }

            return {
                labels: labels,
                datasets: [data]
            }
        },
        options() {
            return {
                responsive: true,
                lineTension: 1,
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                                padding: 25
                            }
                        }
                    ]
                },
                legend: {
                    display: false
                },
                tooltips: {
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return "Count: " + tooltipItem.value
                        }
                    }
                }
            }
        },
        dataTimeline(){
            let collection = []
            let idx = 0

            this.timelines.timeline.forEach(item => {
                collection.push({ id: idx, type: "exam", name: "Ujian " + item.name, time: item.exam_time_start})
                idx++
                collection.push({ id: idx, type: "session", name: item.name, time: item.session_time_start})
                idx++
            })

            return collection
        },
        activeModule() {
            return this.$laravel.active_module
        },
        role(){
            return this.$laravel.roles[this.activeModule.module.identifier]
        },
        currentUser(){
            return  window.Laravel.user.hash
        },
        isAttendant() {
            return this.role == 'attendant'
        }
    },
    methods: {
        getTraining() {
            this.$http
                .get(this.routeUri("api.dashboard.bank"))
                .then(response => {
                    this.trainings = response.data.bank
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loadingBank = false));
        },
        getHigestScore() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.report.classical.highest_score"), {
                    params: {
                        xhr: true,
                        limit: 10
                    }
                })
                .then(response => {
                    this.highest_score = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loadingScores = false));
        },
        getAnnouncements() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.dashboard.announcement"))
                .then(response => {
                    this.announcements = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loadingAnnouncements = false));
        },
        getTimeline() {
            this.loading = true;
            this.$http
                .get(this.routeUri("api.dashboard.classical.timeline"))
                .then(response => {
                    this.timelines = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loadingTimeline = false));
        },
        getGraphics() {
            this.$http
                .get(this.routeUri("api.dashboard.classical.graphic"))
                .then(response => {
                    this.graphics = response.data
                })
                .catch(error => this.handleXhrError(error))
                .finally(() => (this.loading = false));
        },
        viewReport() {
            window.location.href = this.routeUri('admin.classical.report')
        },
        viewReportDetail(hash) {
            let params = {
                attendant: hash
            }

            window.location.href = this.routeUri('admin.classical.attendant.recap.score') + '?' + this.$qs.stringify(params)
        }
    }
};
</script>

<template>
    <div>
        <a-page-header :ghost="false" title="Selamat datang">
            <template #extra>
                <a-space size="large">
                    <strong style="font-size: 15px">{{
                            moment().format("DD MMMM YYYY")
                        }}</strong>
                </a-space>
            </template>

            <a-row type="flex" :gutter="[8, 8]">
                <a-col>
                    <a-avatar
                        :size="64"
                        :src="photo"
                        v-if="photo != null"
                    />
                    <a-avatar class="avatar" :size="64" shape="circle" v-else>{{ initial(username) }}</a-avatar>
                </a-col>
                <a-col>
                    <a-row>
                        <a-col>
                            <strong style="font-size: 20px">{{
                                    username
                                }}</strong>
                        </a-col>
                    </a-row>
                    <a-row align="bottom">
                        <a-col>
                            {{ email }}
                        </a-col>
                    </a-row>
                </a-col>
            </a-row>
        </a-page-header>

        <a-row type="flex" :gutter="[8, 8]">
            <a-col flex="1 1 50%">
                <a-card size="small">
                    <a-skeleton :loading="loadingBank" active>
                        <a-row type="flex" :gutter="24">
                            <a-col flex="0 1 20%">
                                <a-avatar :size="200" v-if="trainings.logo == null" shape="square" >{{ trainings.name }}</a-avatar>
                                <img :src="trainings.logo" v-else />
                            </a-col>
                        </a-row>
                    </a-skeleton>
                </a-card>

                <a-row type="flex" :gutter="[8, 8]" style="margin-top:8px">
                    <a-col flex="0 1 25%">
                        <a-card size="small">
                            <a-skeleton :loading="loading" active>
                                <strong>NILAI RATA-RATA</strong>
                                <classical-dashboard-chart :chart-data="chartData" :options="options" v-if="!loading" style="margin-top:10px"></classical-dashboard-chart>
                            </a-skeleton>
                        </a-card>
                    </a-col>
                    <a-col flex="1 1 50%">
                        <a-card size="small">
                            <a-skeleton :loading="loadingAnnouncements" active>
                                <a-list bordered :data-source="announcements.announcements">
                                    <a-list-item slot="renderItem" slot-scope="item, index">
                                        <a :href="routeUri('admin.classical.announcement')">{{ item.title }}</a>
                                    </a-list-item>
                                    <div slot="header">
                                        <strong>PENGUMUMAN</strong>
                                    </div>
                                </a-list>
                            </a-skeleton>
                        </a-card>
                    </a-col>
                </a-row>
            </a-col>

            <a-col flex="1 0 24%">
                <a-row type="flex" :gutter="[8, 8]">
                    <a-col :span="24">
                        <a-card size="small">
                            <a-skeleton :loading="loadingTimeline" active>
                                <div style="margin-bottom:10px"><strong>JADWAL SESI</strong></div><br/>
                                <a-timeline>
                                    <a-timeline-item v-for="item in dataTimeline" :key="item.id" :color="item.type == 'exam' ? 'red' : 'blue'">
                                        <a-icon slot="dot" type="clock-circle-o" style="font-size: 16px;" v-if="item.type == 'exam'" />
                                        {{ item.name }} <i><b>[{{ item.time }}]</b></i>
                                    </a-timeline-item>
                                </a-timeline>
                            </a-skeleton>
                        </a-card>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>

        <div id="components-back-top-demo-custom">
            <a-back-top>
                <div class="ant-back-top-inner">
                    <a-icon type="up-circle" />
                </div>
            </a-back-top>
        </div>
    </div>
</template>

<style scoped>
#components-back-top-demo-custom .ant-back-top {
    bottom: 100px;
}
#components-back-top-demo-custom .ant-back-top-inner {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 4px;
    background-color: #1088e9;
    color: #fff;
    text-align: center;
    font-size: 20px;
}

.column {
    flex: 100% !important; /* !important so that it overrides the inline style because by default it has higher priority */
}
</style>
